import { useContext } from 'react';

import { ExamRoomRequestInfoContext } from './exam-room-request-info-provider';

function useExamRoomRequestInfo() {
  const context = useContext(ExamRoomRequestInfoContext);

  if (!context) {
    throw new Error('useExamRoomRequestInfo must be used within a ExamRoomRequestInfoProvider');
  }

  return context;
}

export { useExamRoomRequestInfo };
